import MainLayout from "layouts/main";
import HomePage from "pages/home";
import ReDeadlinePage from "pages/re-deadline";
import SchedulePage from "pages/schedule";
import {Navigate, useRoutes} from "react-router-dom";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <MainLayout/>,
      children: [
        {index: true, element: <HomePage/>},
        {path: "managers", element: <HomePage/>},
        {path: "working-hours", element: <HomePage/>},
        {path: "schedule", element: <SchedulePage/>},
        {path: "task-re-deadline", element: <ReDeadlinePage/>},
        {path: "schedule/:id", element: <SchedulePage/>},
        {path: "md", element: <HomePage/>},
        {path: "employee", element: <HomePage/>},
        {path: "explanation-letter", element: <HomePage/>},
        {path: "employee-attendance", element: <HomePage/>},
        {path: "partners", element: <HomePage/>},
      ],
    },
    {path: "*", element: <Navigate to="/" replace/>},
  ]);
}
